import { useMemo } from 'react';
import { getRovoAgentsPluginState } from '../../pm-plugins/rovo-agents/plugin-factory';
/**
 * A memoized getter for rovo plugin state (enabled, agents, etc).
 */
export function useAgents(_ref) {
  var editorState = _ref.editorState;
  var pluginState = useMemo(function () {
    var rovoAgentsPluginState = getRovoAgentsPluginState(editorState);
    return rovoAgentsPluginState;
  }, [editorState]);
  return pluginState;
}